import { Button } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/** Состояние модерации ещё не приехало (или упало) — секций доступа нет вовсе. */
export const StatusLoadLine = ({ isError, onRetry }: { isError: boolean; onRetry: () => void }) => {
  const m = useMessages(messages)
  return (
    <div className="flex items-center justify-between gap-3 text-sm text-muted-foreground">
      <span>{isError ? m.statusLoadFailed : m.statusLoading}</span>
      {isError ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {m.retry}
        </Button>
      ) : null}
    </div>
  )
}
